<template>
  <footer id="renew2-footer" class="renew2_footer">
    <div class="renew2_wrapper">
      <section class="footer_notice" aria-labelledby="footer-notice-title">
        <h2 id="footer-notice-title" class="footer_notice_title">
          【重要】当サイトは安全にご利用いただけます（現在話題となっているPHP関連の問題について）
        </h2>
        <p class="footer_notice_body">
          平素よりyagishをご利用いただき、誠にありがとうございます。現在、SNS等で話題となっているPHPのシステム関連の問題につきまして、当社サービス「yagish」では影響を受けない環境であることを確認しております。ユーザーの皆様のデータは適切に保護されておりますので、これまで通り安全に履歴書作成等のサービスをご利用いただけます。ご心配をおかけいたしましたが、引き続きyagishをよろしくお願い申し上げます。
        </p>
      </section>

      <div class="flex footer_top">
        <a href="/" class="ft-link"
          ><img
            src="/static/renew2_img/logo.svg"
            alt="ヤギッシュ"
            class="ft-img"
        /></a>
        <p class="ft-lead">
          yagish（ヤギッシュ）は、ブラウザ上で履歴書がつくれる無料サービスです。
        </p>
      </div>

      <div class="footer_middle">
        <ul class="flex fm-btn-linklist">
          <li class="fm-btn-linkitem">
            <a href="/format/rirekisho_job_change" class="fm-btn-link">
              <img
                src="/static/renew2_img/fm-btn-img01.png"
                alt="履歴書を作る"
                class="fm-btn-img"
              />
            </a>
          </li>
          <li class="fm-btn-linkitem">
            <a href="/info" class="fm-btn-link">
              <img
                src="/static/renew2_img/fm-btn-img02.png"
                alt="yagishの使いかた"
                class="fm-btn-img"
              />
            </a>
          </li>
          <li class="fm-btn-linkitem">
            <a href="/help" class="fm-btn-link">
              <img
                src="/static/renew2_img/fm-btn-img03.png"
                alt="よくある質問"
                class="fm-btn-img"
              />
            </a>
          </li>
        </ul>

        <!--<ul class="flex fm-linklist">
          <li class="fm-linkitem">
            <a href="/servicelist" class="fm-link">サービス一覧</a>
          </li>
          <li class="fm-linkitem">
            <a href="/price" class="fm-link">料金表</a>
          </li>
          <li class="fm-linkitem"></li>
        </ul>-->

        <ul class="flex fm-linklist">
          <li class="fm-linkitem">
            <a href="/format/rirekisho_job_change" class="fm-link"
              >履歴書作成</a
            >
          </li>
          <li class="fm-linkitem">
            <a href="/static/ocr/" class="fm-link">履歴書を読み取る(OCR)</a>
          </li>
          <li class="fm-linkitem">
            <a href="/static/know-how/" class="fm-link"
              >履歴書書き方完全ガイド</a
            >
          </li>
          <li class="fm-linkitem">
            <a href="/format/shokumukeirekisho" class="fm-link"
              >職務経歴書作成</a
            >
          </li>
          <li class="fm-linkitem">
            <a href="/format/letter" class="fm-link">送付状作成</a>
          </li>
          <li class="fm-linkitem">
            <a
              href="#"
              class="fm-link"
              @click.prevent="openTemplateApp('footer')"
              >請求書・見積書作成</a
            >
          </li>
          <li class="fm-linkitem">
            <a href="/format/rirekisho_arbeit_debut" class="fm-link"
              >アルバイトデビュー履歴書</a
            >
          </li>
          <template v-if="isAuthenticated">
            <li class="fm-linkitem">
              <a href="/ai/interview_practice" class="fm-link">AI面接練習</a>
            </li>
            <li class="fm-linkitem">
              <a href="/ai/self_analysis" class="fm-link">AI自己分析</a>
            </li>
            <li class="fm-linkitem">
              <a href="/ai/aptitude_practice" class="fm-link">AI適性検査</a>
            </li>
          </template>
          <!--<li class="fm-linkitem">
            <a href="https://www.yagish.jp/service/daigakuyagish/" target="_blank"
              class="fm-link fm-link-tab">各大学専用履歴書</a>
          </li>
          <li class="fm-linkitem">
            <a href="/quickemailhelp" class="fm-link">ヤギのメール便（企業に送信）</a>
          </li>
          <li class="fm-linkitem">
            <a href="/fontservicehelp" class="fm-link">フォントサービス</a>
          </li>
          <li class="fm-linkitem">
            <a href="/yagiprimeinfo" class="fm-link">ヤギプライム</a>
          </li>
          <li class="fm-linkitem">
            <a href="https://www.yagish.jp/business/yagibot/" target="_blank"
              class="fm-link fm-link-tab">yagibot（LINEで履歴書作成）</a>
          </li>
          <li class="fm-linkitem">
            <a href="https://www.yagish.jp/business/yagitime/" target="_blank"
              class="fm-link fm-link-tab">大学生スケジュールアプリ</a>
          </li>
          <li class="fm-linkitem">
            <a href="/yagidigram" class="fm-link">ヤギディ(性格)診断</a>
          </li>
          <li class="fm-linkitem">
            <a href="https://www.youtube.com/@yagish-df1zb" target="_blank" class="fm-link fm-link-tab">公式YouTube</a>
          </li>
          <li class="fm-linkitem" v-if="appMode !== 'productionX'">
            <a href="https://resume.yagish.net/" target="_blank" class="fm-link fm-link-tab">韓国版履歴書サイト</a>
          </li>-->
          <li class="fm-linkitem"></li>
        </ul>
      </div>

      <div v-if="isAuthenticated" class="flex footer_middle02">
        <a
          href="https://store.line.me/stickershop/author/4427017/ja"
          class="fm02-link"
          target="_blank"
        >
          <img
            src="/static/mypage/linestampbnr.png"
            alt="LINEスタンプ"
            class="fm02-linkimg"
          />
        </a>
        <a href="/yagiprimeinfo" class="fm02-link">
          <img
            src="/static/mypage/primebnr.png"
            alt="ヤギプライム"
            class="fm02-linkimg"
          />
        </a>
        <a href="/yagidigram" class="fm02-link">
          <img
            src="/static/mypage/digrambnr.png"
            alt="ヤギディ診断"
            class="fm02-linkimg"
          />
        </a>
        <a
          href="https://www.youtube.com/@yagish-df1zb"
          class="fm02-link"
          target="_blank"
        >
          <img
            src="/static/mypage/youtubebnr.png"
            alt="公式youtube"
            class="fm02-linkimg"
          />
        </a>
        <a href="/quickemailhelp" class="fm02-link" target="_blank">
          <img
            src="/static/mypage/mail-banner.png"
            alt="メール便"
            class="fm02-linkimg"
          />
        </a>
        <a href="https://privacymark.jp/" class="fm02-link" target="_blank">
          <img
            src="/static/mypage/pmarkbnr.png"
            alt="Pマーク"
            class="fm02-linkimg"
          />
        </a>
        <a
          tabindex="-1"
          class="fm02-link"
          target="_blank"
          style="margin-bottom: 0"
        ></a>
      </div>

      <div class="footer_bottom">
        <ul class="flex fb-linklist">
          <li class="fb-linkitem">
            <a href="https://www.yagish.jp/" target="_blank" class="fb-link"
              >運営会社</a
            >
          </li>
          <li class="fb-linkitem">
            <a
              href="https://www.yagish.jp/privacy/"
              target="_blank"
              class="fb-link"
              >個人情報保護方針</a
            >
          </li>
          <li class="fb-linkitem">
            <a
              href="https://www.yagish.jp/privacy_policy/"
              target="_blank"
              class="fb-link"
              >プライバシーポリシー</a
            >
          </li>
          <li class="fb-linkitem">
            <a href="/law" class="fb-link">特定商取引法に基づく表示</a>
          </li>
          <li class="fb-linkitem">
            <a href="/terms" class="fb-link">利用規約</a>
          </li>
        </ul>

        <ul class="flex fb-linklist">
          <li class="fb-linkitem">
            <a
              href="https://www.yagish.jp/recruit/"
              target="_blank"
              class="fb-link"
              >採用情報</a
            >
          </li>
          <li class="fb-linkitem">
            <a
              href="/contact"
              target="_blank"
              rel="noopener noreferrer"
              class="fb-link"
              >お問い合わせ</a
            >
          </li>
        </ul>
      </div>

      <div
        v-if="appMode !== 'production'"
        class="renew2_flex renew2_sp_flex"
        style="justify-content: center; margin-top: 10px"
      >
        <el-button
          type="success"
          style="background-color: #0f9934; border-color: #0f9934"
          @click="$emit('ios-send')"
          >iOS送信しました{{ eventValue }}</el-button
        >
        <el-button
          type="success"
          style="background-color: #0f9934; border-color: #0f9934"
          @click="$emit('android-send')"
          >Android送信しました</el-button
        >
      </div>

      <p class="copyright">
        ©2021-<span v-text="new Date().getFullYear()"></span> Yagish Co., Ltd.
        All rights reserved.
      </p>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useAuth } from '@/composables/useAuth'
import { useTemplateApp } from '@/composables/useTemplateApp'

defineProps<{
  /** 非 production のデバッグボタンに表示する通知イベント値 */
  eventValue?: string
}>()

defineEmits<{
  (e: 'ios-send'): void
  (e: 'android-send'): void
}>()

const { isAuthenticated } = useAuth()
const { open: openTemplateApp } = useTemplateApp()

/** 移設元の getMode 相当。ビルド時定数なので computed にしない */
const appMode = process.env.VUE_APP_MODE
</script>

<style scoped>
.footer_notice {
  margin: 0 0 24px;
  padding: 16px 20px;
  border: 2px solid #d9534f;
  border-radius: 8px;
  background-color: #fff;
  text-align: left;
}

.footer_notice_title {
  margin: 0 0 8px;
  color: #d9534f;
  font-size: 15px;
  font-weight: bold;
  line-height: 1.5;
}

.footer_notice_body {
  margin: 0;
  color: #333;
  font-size: 13px;
  line-height: 1.8;
}
</style>
